import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onFocus", "onOpenChange", "saveDisabled", "saveOnEnter", "onSave", "composing", "cancelButtonUse", "cancelLabel", "children", "okButtonUse", "onCancel", "open", "responsive", "saveLabel", "use"];
import { Controllable } from '../Controllable/Controllable';
import { useRef } from 'react';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { Button } from '../Button/Button';
import { SlideoutDrawer } from '../SlideoutDrawer/SlideoutDrawer';
import { lazyEval } from '../../utils/lazyEval';
import { IMEAware } from '../../utils/IMEAware/IMEAware';
import { View } from '../../../components/View/View';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EditableControlsComponent = _ref => {
  let {
      onFocus,
      onOpenChange,
      saveDisabled = false,
      saveOnEnter = true,
      onSave,
      composing,
      cancelButtonUse = 'tertiary-light',
      cancelLabel = () => 'Cancel',
      children,
      okButtonUse = 'tertiary',
      onCancel,
      open = false,
      responsive = true,
      saveLabel = () => 'Save',
      use = 'inset'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _el = useRef(null);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const handleSave = () => {
    var _el$current;
    if (_el) (_el$current = _el.current) === null || _el$current === void 0 || _el$current.focus();
    if (onOpenChange) onOpenChange(syntheticEvent(false));
    if (onSave) onSave();
  };
  const handleCancel = () => {
    var _el$current2;
    if (_el) (_el$current2 = _el.current) === null || _el$current2 === void 0 || _el$current2.focus();
    if (onOpenChange) onOpenChange(syntheticEvent(false));
    if (onCancel) onCancel();
  };
  const handleFocus = evt => {
    if (onOpenChange) onOpenChange(syntheticEvent(true));
    if (onFocus) onFocus(evt);
  };
  const handleKeyDown = evt => {
    if (composing) return;
    const {
      key
    } = evt;
    if (key === 'Enter' && !saveDisabled && (saveOnEnter || evt.metaKey || evt.ctrlKey)) {
      handleSave();
    }
    if (key === 'Escape') {
      handleCancel();
    }
  };
  const handleChange = () => {
    if (onOpenChange) onOpenChange(syntheticEvent(true));
  };
  return /*#__PURE__*/_jsx(View, Object.assign({}, domProps, {
    backgroundColor: use === 'flush' ? 'fill-transparent-default' : 'fill-surface-raised',
    marginBlockStart: use === 'flush' ? '300' : '200',
    marginBlockEnd: use === 'flush' ? '300' : '0',
    paddingBlock: use === 'flush' ? '0' : '200',
    paddingInline: use === 'flush' ? '0' : '400'
  }, tokenProps, {
    children: /*#__PURE__*/_jsxs("div", {
      onChange: handleChange,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      ref: _el,
      children: [children, /*#__PURE__*/_jsx(SlideoutDrawer, {
        open: open,
        children: /*#__PURE__*/_jsxs(View, {
          paddingBlockEnd: "0",
          children: [/*#__PURE__*/_jsx(Button, {
            disabled: saveDisabled,
            onClick: handleSave,
            responsive: responsive,
            size: "extra-small",
            use: okButtonUse,
            children: lazyEval(saveLabel)
          }), /*#__PURE__*/_jsx(Button, {
            onClick: handleCancel,
            responsive: responsive,
            size: "extra-small",
            use: cancelButtonUse,
            children: lazyEval(cancelLabel)
          })]
        }, "controls")
      })]
    })
  }));
};
export const EditableControls = IMEAware(Controllable(EditableControlsComponent, ['open']));